import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Button, Paper, Text, Title,
} from '@mantine/core';
import { IconCreditCardOff } from '@tabler/icons-react';
import routes from '@/routes';
import styles from './paymentError.module.css';

const PaymentError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const contactEmail = t('pages.paymentError.actions.contactEmail');

  return (
    <div className={styles.page}>
      <Paper shadow="md" radius="lg" p="xl" className={styles.card}>
        <IconCreditCardOff size={64} color="var(--mantine-color-red-5)" stroke={1.5} />
        <Title order={2}>{t('pages.paymentError.title')}</Title>
        <Text c="dimmed" ta="center">
          {t('pages.paymentError.message')}
        </Text>
        <div className={styles.buttons}>
          <Button variant="filled" fullWidth onClick={() => navigate(routes.main.path)}>
            {t('pages.paymentError.actions.home')}
          </Button>
          <Button component="a" href={`mailto:${contactEmail}`} variant="subtle" fullWidth>
            {t('pages.paymentError.actions.contact')}
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default PaymentError;
